"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importStar(require("react"));
var Chip_1 = __importDefault(require("@material-ui/core/Chip"));
var Autocomplete_1 = __importStar(require("@material-ui/lab/Autocomplete"));
var noop_1 = __importDefault(require("lodash/noop"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var ClearButton_1 = require("../ClearButton");
var icons_1 = require("../icons");
var CornerDown_1 = require("../icons/CornerDown");
var ListItem_1 = require("../ListItem");
var Tooltip_1 = require("../Tooltip");
var Input_1 = require("./Input");
var styles_1 = require("./styles");
var filter = (0, Autocomplete_1.createFilterOptions)();
var isAddNewOption = function (option) {
    return (option === null || option === void 0 ? void 0 : option.type) === 'add-new-option';
};
var isNoOptionsOption = function (option) {
    return (option === null || option === void 0 ? void 0 : option.type) === 'no-options-option';
};
var inputRootRightPaddings = (_a = {},
    _a[system_1.InputVariants.Frame] = 34,
    _a[system_1.InputVariants.Float] = 34,
    _a[system_1.InputVariants.Line] = 20,
    _a.default = 20,
    _a);
var inputRootLeftPaddings = (_b = {},
    _b[system_1.InputVariants.Frame] = 0,
    _b[system_1.InputVariants.Float] = 2,
    _b[system_1.InputVariants.Line] = 0,
    _b.default = 0,
    _b);
var useAutocompleteStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: {
        width: '100%',
        display: 'inline-block',
    },
    inputRoot: function (_a) {
        var multiple = _a.multiple, variant = _a.variant;
        return multiple
            ? {
                padding: "0px ".concat((variant && inputRootRightPaddings[variant]) ||
                    inputRootRightPaddings.default, "px 0px ").concat((variant && inputRootLeftPaddings[variant]) ||
                    inputRootLeftPaddings.default, "px !important"),
            }
            : {};
    },
    input: function (props) { return ({
        padding: (0, styles_1.getPaddings)(props),
    }); },
    clearIndicator: {
        '$root &': {
            margin: 0,
            padding: 0,
            '&:hover': {
                background: 'none',
            },
        },
        '$input[value=""] + $endAdornment &, $input:not([value]) + $endAdornment &': {
            visibility: 'hidden',
        },
        '$inputRoot:hover $endAdornment &': {
            visibility: 'visible',
        },
    },
    popupIndicator: {
        '$root &': {
            color: theme.go.schemes.colors.system.IconMain,
            margin: 0,
            height: 28,
            padding: 0,
            '&:hover': {
                background: 'none',
            },
        },
    },
    endAdornment: function (_a) {
        var variant = _a.variant;
        return variant === system_1.InputVariants.Frame || variant === system_1.InputVariants.Float
            ? {
                right: '6px !important',
            }
            : {};
    },
    addOptionIcon: {
        marginRight: theme.go.schemes.spacing.units.S,
        color: '#4D40F9',
    },
    paper: theme.go.mixins.paper,
    listbox: {
        padding: theme.go.schemes.spacing.units.S,
    },
    checkOptionIcon: {
        color: theme.go.schemes.components.lists.selectedTextColor,
    },
    option: {
        padding: 0,
        '&[aria-selected="true"]': {
            backgroundColor: 'transparent',
            color: theme.go.schemes.colors.system.TextMain,
        },
        '&[data-focus="true"]': {
            backgroundColor: theme.go.schemes.colors.system.BgMinor,
            borderRadius: 16,
        },
    },
    tag: __assign(__assign(__assign(__assign({ borderRadius: 12, height: 32, margin: 2, backgroundColor: theme.go.schemes.colors.system.ButtonMinor, color: theme.go.schemes.colors.system.TextMain }, theme.go.mixins.effects.Hovered()), theme.go.mixins.effects.Pressed()), theme.go.mixins.typography.Body), { 'span&': {
            minWidth: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 5,
        }, '& + input': {
            marginLeft: 10,
            paddingLeft: '0 !important',
        } }),
    label: function (_a) {
        var variant = _a.variant, multiple = _a.multiple;
        return ({
            marginBottom: "".concat(multiple && variant === system_1.InputVariants.Line ? '0px !important' : undefined),
        });
    },
}); }, { name: 'GoAutocomplete' });
var useChipsStyles = (0, system_1.makeStyles)(function (theme) { return ({
    deleteIcon: {
        color: theme.go.schemes.colors.system.IconMinor,
        flexShrink: 0,
        '&:hover': {
            color: theme.go.schemes.colors.system.IconMinor,
        },
    },
}); });
function SelectComponent(_a) {
    var inputProps = _a.inputProps, renderOption = _a.renderOption, renderInput = _a.renderInput, getOptionSelected = _a.getOptionSelected, creatable = _a.creatable, _b = _a.noOptionsText, noOptionsText = _b === void 0 ? 'Ничего не найдено' : _b, _c = _a.getOptionLabel, getOptionLabel = _c === void 0 ? function (option) { return (typeof option === 'string' ? option : ''); } : _c, _d = _a.onAddNewOption, onAddNewOption = _d === void 0 ? noop_1.default : _d, _e = _a.getAddNewOptionLabel, getAddNewOptionLabel = _e === void 0 ? function (option) { return "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C ".concat(option); } : _e, _f = _a.onChange, onChange = _f === void 0 ? noop_1.default : _f, 
    // @ts-ignore
    _g = _a.filterOptions, 
    // @ts-ignore
    filterOptions = _g === void 0 ? filter : _g, _h = _a.getOptionDisabled, getOptionDisabled = _h === void 0 ? function () { return false; } : _h, loading = _a.loading, _j = _a.InputComponent, InputComponent = _j === void 0 ? Input_1.Input : _j, showAddOption = _a.showAddOption, props = __rest(_a, ["inputProps", "renderOption", "renderInput", "getOptionSelected", "creatable", "noOptionsText", "getOptionLabel", "onAddNewOption", "getAddNewOptionLabel", "onChange", "filterOptions", "getOptionDisabled", "loading", "InputComponent", "showAddOption"]);
    var chipsStyles = useChipsStyles();
    var _k = useAutocompleteStyles({
        variant: inputProps === null || inputProps === void 0 ? void 0 : inputProps.variant,
        multiple: props.multiple,
        clearable: inputProps === null || inputProps === void 0 ? void 0 : inputProps.clearable,
        disabled: props === null || props === void 0 ? void 0 : props.disabled,
        iconStart: inputProps === null || inputProps === void 0 ? void 0 : inputProps.iconStart,
        select: true,
        multi: props.multiple,
    }), label = _k.label, checkOptionIcon = _k.checkOptionIcon, addOptionIcon = _k.addOptionIcon, autocompleteStyles = __rest(_k, ["label", "checkOptionIcon", "addOptionIcon"]);
    var limitTags = props.limitTags, classes = props.classes;
    var _l = __read((0, react_1.useState)(false), 2), focused = _l[0], setFocused = _l[1];
    var renderValueOptionDefault = (0, react_1.useCallback)(function (option, _a) {
        var selected = _a.selected;
        var title = getOptionLabel(option);
        return (react_1.default.createElement(ListItem_1.ListItem, { title: title, endElement: selected ? react_1.default.createElement(icons_1.CheckIcon, { className: checkOptionIcon }) : undefined, selected: selected }));
    }, [checkOptionIcon, getOptionLabel]);
    var renderValueOption = renderOption || renderValueOptionDefault;
    var renderOptionFabric = (0, react_1.useCallback)(function (option, state) {
        if (isAddNewOption(option)) {
            var title = getAddNewOptionLabel(option.value);
            return (react_1.default.createElement(ListItem_1.ListItem, { title: title, endElement: react_1.default.createElement(icons_1.PlusIcon, { className: addOptionIcon }) }));
        }
        if (isNoOptionsOption(option)) {
            return react_1.default.createElement(ListItem_1.ListItem, { title: noOptionsText });
        }
        return renderValueOption(option, state);
    }, [addOptionIcon, getAddNewOptionLabel, noOptionsText, renderValueOption]);
    var handleChange = (0, react_1.useCallback)(function (event, newValue, reason) {
        var addOption = Array.isArray(newValue)
            ? newValue.find(isAddNewOption)
            : isAddNewOption(newValue);
        if (addOption) {
            onAddNewOption(addOption === true ? newValue.value : addOption.value);
        }
        else {
            onChange(event, newValue, reason);
        }
    }, [onAddNewOption, onChange]);
    var renderTags = (0, react_1.useCallback)(function (value, getTagProps) {
        var limit = focused ? undefined : limitTags;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            value.slice(0, limit).map(function (v, i) { return (react_1.default.createElement(Chip_1.default, __assign({ key: i, label: (getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(v)) || v }, getTagProps({ index: i }), { classes: chipsStyles, deleteIcon: react_1.default.createElement(ClearButton_1.ClearButton, null) }))); }),
            !!limit && value.length > limit && (react_1.default.createElement(Tooltip_1.Tooltip, { placement: "right", invert: true, title: value
                    .slice(limitTags)
                    .map(function (v) { return (getOptionLabel === null || getOptionLabel === void 0 ? void 0 : getOptionLabel(v)) || v; })
                    .join('\n') },
                react_1.default.createElement("span", { className: autocompleteStyles.tag }, "+".concat(value.length - limit))))));
    }, [focused, limitTags, autocompleteStyles.tag, getOptionLabel, chipsStyles]);
    var onFocus = (0, react_1.useCallback)(function () {
        setFocused(true);
    }, []);
    var onBlur = (0, react_1.useCallback)(function () {
        setFocused(false);
    }, []);
    var renderInputDefault = (0, react_1.useCallback)(function (params) {
        var _a, _b;
        var endAdornmentProps = (params === null || params === void 0 ? void 0 : params.InputProps.endAdornment).props;
        var endAdornmentChildren = (react_1.default.createElement(react_1.default.Fragment, null, (_a = inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputProps) === null || _a === void 0 ? void 0 :
            _a.endAdornment,
            endAdornmentProps.children));
        return (react_1.default.createElement(InputComponent, __assign({}, __assign(__assign(__assign({}, params), inputProps), { InputLabelProps: __assign(__assign({}, inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputLabelProps), { className: (0, utils_1.cn)(label, (_b = inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputLabelProps) === null || _b === void 0 ? void 0 : _b.className) }), InputProps: __assign(__assign(__assign({}, params === null || params === void 0 ? void 0 : params.InputProps), inputProps === null || inputProps === void 0 ? void 0 : inputProps.InputProps), { endAdornment: (params === null || params === void 0 ? void 0 : params.InputProps.endAdornment)
                    ? react_1.default.cloneElement(params === null || params === void 0 ? void 0 : params.InputProps.endAdornment, endAdornmentProps.props, endAdornmentChildren)
                    : null }) }))));
    }, [inputProps, label, InputComponent]);
    var showAddOptionDefault = (0, react_1.useCallback)(function (inputValue, filtered) {
        return !!inputValue &&
            !filtered.some(function (option) {
                return getOptionLabel(option) === inputValue;
            });
    }, [getOptionLabel]);
    var handleFilterOptions = (0, react_1.useCallback)(function (options, params) {
        var addNewOption = {
            type: 'add-new-option',
            value: params.inputValue,
        };
        var noOptionsOption = {
            type: 'no-options-option',
        };
        var filtered = loading ? options : filterOptions(options, params);
        var hasOptions = filtered.length;
        var showAdd = creatable && (showAddOption || showAddOptionDefault)(params.inputValue, filtered);
        if (hasOptions) {
            return showAdd ? __spreadArray(__spreadArray([], __read(filtered), false), [addNewOption], false) : filtered;
        }
        return showAdd ? [noOptionsOption, addNewOption] : [noOptionsOption];
    }, [loading, filterOptions, creatable, showAddOption, showAddOptionDefault]);
    var handleGetOptionDisabled = (0, react_1.useCallback)(function (option) {
        return getOptionDisabled(option) || isNoOptionsOption(option);
    }, [getOptionDisabled]);
    return (react_1.default.createElement(Autocomplete_1.default, __assign({ onFocus: onFocus, onBlur: onBlur, onChange: handleChange, filterOptions: handleFilterOptions, getOptionLabel: getOptionLabel, renderInput: renderInput || renderInputDefault, closeIcon: react_1.default.createElement(ClearButton_1.ClearButton, null), popupIcon: react_1.default.createElement(CornerDown_1.CornerDownIcon, null), selectOnFocus: false, clearText: "", closeText: "", openText: "", autoComplete: true, renderOption: renderOptionFabric, renderTags: renderTags, getOptionSelected: getOptionSelected, disableCloseOnSelect: !!props.multiple, disableClearable: (inputProps === null || inputProps === void 0 ? void 0 : inputProps.clearable) === false || props.multiple, loading: loading, getOptionDisabled: handleGetOptionDisabled }, props, { classes: utils_1.cn.merge(autocompleteStyles, classes) })));
}
exports.Select = react_1.default.memo(SelectComponent);
